import BaseLayout from '../../layout/BaseLayout';
import {GenericError} from './GenericError';

export const INVALID_INVITATION_TITLE = 'This invitation is no longer valid';
export const INVALID_INVITATION_DESCRIPTION =
  'Your invite may have expired, been canceled, or already been used. Ask the person who invited you for a new one, or contact support at';

// Same message for every invalid case so the page doesn't reveal whether an invitation exists.
export function InvalidInvitationPage() {
  return (
    <BaseLayout transparentBackground>
      <GenericError
        errorCode={404}
        title={INVALID_INVITATION_TITLE}
        description={INVALID_INVITATION_DESCRIPTION}
      />
    </BaseLayout>
  );
}
